import { render, staticRenderFns } from "./StatsCampaignsBox.vue?vue&type=template&id=2d51e2de&scoped=true&"
import script from "./StatsCampaignsBox.vue?vue&type=script&lang=js&"
export * from "./StatsCampaignsBox.vue?vue&type=script&lang=js&"
import style0 from "./StatsCampaignsBox.vue?vue&type=style&index=0&id=2d51e2de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d51e2de",
  null
  
)

export default component.exports